/**
 * Every string DismissRequestDialog shows by default. The caller can replace any of them through
 * the `copy` prop. The warning and the information line are the copy review wording of
 * verifime-adr#683, approved by Zoe McKeough on 2026-11-04. The title and the two buttons are
 * CANDIDATE COPY, not approved: awaiting Charles's approval before merge (verifime-adr#617).
 */

export type DismissRequestDialogCopy = {
  /** The title, and the name of the dialog for a screen reader. */
  title: (providerName: string) => string;
  /** What declining means for the customer: the warning, in one block. */
  warning: string;
  /** The line after the warning. It is information. */
  newInvite: string;
  /** The button that closes the request for good. */
  decline: string;
  /** The safe button that leaves the request open. */
  goBack: string;
};

export const DISMISS_REQUEST_DIALOG_COPY: DismissRequestDialogCopy = {
  // CANDIDATE COPY, not approved (verifime-adr#617)
  title: (providerName) => `Decline the request from ${providerName}?`,
  // COPY APPROVED (verifime-adr#683): Zoe McKeough, 2026-11-04
  warning:
    'Your service provider may have regulatory obligations explaining this request for information from you. If you decline this request, this may stop them from working with you. Please contact your provider for further information.',
  // COPY APPROVED (verifime-adr#683): Zoe McKeough, 2026-11-04
  newInvite: 'If they ask you to verify again, they must send a new invite.',
  // CANDIDATE COPY, not approved (verifime-adr#617)
  decline: 'Decline',
  // CANDIDATE COPY, not approved (verifime-adr#617)
  goBack: 'Go back',
};

/** Overrides for the default copy. Any string may be left out. A string set to `undefined` counts as left out. */
export type DismissRequestDialogCopyOverrides = Partial<DismissRequestDialogCopy>;

/** The default copy with the caller's overrides laid over it, one string at a time. */
export function resolveDismissRequestDialogCopy(
  overrides: DismissRequestDialogCopyOverrides = {},
): DismissRequestDialogCopy {
  const given = Object.fromEntries(
    Object.entries(overrides).filter(([, text]) => text !== undefined),
  );
  return { ...DISMISS_REQUEST_DIALOG_COPY, ...given };
}
